import {
  PROJECTS_QUERY_KEY,
  PROJECTS_REFETCH_INTERVAL_MS,
} from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { projectApi } from "@/api/services";

// NOTE: NSAI-5021 — the list is returned exactly as the server sent it. It used
// to be filtered down to the single organization a SAML session authenticated
// against, which silently hid every OTHER organization the user belongs to: the
// org never reached the switcher, and because the rest of the app treats this
// list as the authority on what is reachable, a notification deep link or a
// direct URL into one of those orgs resolved back to the SAML org instead.
//
// NOTE: dropping the filter grants no new access. Membership is enforced
// server-side — JwtAuthGuard resolves the `X-Project-Uuid` header through
// ProjectService.getProjectWithAccessCheck, which verifies real project
// membership and answers 403 otherwise — so this filter only ever hid rows the
// API was already willing to serve to this user. The SAML organization still
// decides where the session LANDS, via `resolveInitialProjectUuid`'s
// `preferredOrganizationUuid`; it is a preference now, not a boundary.
export const useGetProjects = (enabled: boolean) => {
  return useQuery({
    queryKey: [PROJECTS_QUERY_KEY],
    enabled,
    refetchInterval: PROJECTS_REFETCH_INTERVAL_MS,
    // NOTE: NSAI-4865 — overrides the global `refetchOnWindowFocus: false` for
    // this query only. `refetchInterval` alone does not poll while the window is
    // blurred (refetchIntervalInBackground defaults to false), so a session left
    // in a background tab keeps rendering the project list as it was when the
    // user looked away — including an organization they have since been
    // de-provisioned from. Refetching on focus means the switcher can't offer a
    // project the user has lost.
    refetchOnWindowFocus: true,
    queryFn: () => projectApi.getProjects(),
  });
};
